import { Component, Vue } from 'vue-property-decorator';
import { Spinner as LoadingSpinner } from '@/components/spinners';
import { StatusEnum, ILoaderMixin } from './types';

@Component({
  components: {
    LoadingSpinner,
  },
})
export default class LoaderMixin extends Vue implements ILoaderMixin {
  public status: string = StatusEnum.PREPARE;

  get isError(): boolean {
    return this.status === StatusEnum.ERROR;
  }

  get isLoading(): boolean {
    return this.status === StatusEnum.LOADING;
  }

  get isReady(): boolean {
    return this.status !== StatusEnum.PREPARE;
  }

  setStatus(value: string): void {
    switch (value) {
      case 'error':
        this.status = StatusEnum.ERROR;
        break;
      case 'success':
        this.status = StatusEnum.SUCCESS;
        break;
      default:
        this.status = StatusEnum.LOADING;
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/profile/mixins/LoaderMixin.ts